import React from "react";

export default function ExpiredPromotion() {
  return (
    <div className="relative w-full h-screen">
      <img
        src="/images/kuga4990/background.jpg"
        alt="Фоново изображение"
        className="object-cover w-full h-full"
      />
      <div className="absolute inset-0 flex items-center justify-center bg-black/60">
        <h1 className="text-3xl text-center text-white lg:text-5xl">
          Тази промоция вече не е активна
        </h1>
      </div>
    </div>
  );
}
